import { useSelector } from "react-redux";
import { getViewportCategory } from "../../../state/modules/layout/selectors";
import { getCategoryHeaderDescription } from "../../../state/modules/category";
import { withTranslation } from "../../translation";
import CategoryHeaderDescription from "./CategoryHeaderDescription";
import PropTypes from "prop-types";

const CategoryHeaderDescriptionContainer = ({ device }) => {
  const viewport = useSelector(getViewportCategory);
  const description = useSelector(getCategoryHeaderDescription);

  return (
    <CategoryHeaderDescription
      viewport={viewport}
      description={description}
      device={device}
    />
  );
};

CategoryHeaderDescriptionContainer.propTypes = {
  device: PropTypes.string
};

export default withTranslation(CategoryHeaderDescriptionContainer);
